    @if (customerDetailLoading) {
        <ui-loading-spinner></ui-loading-spinner>
    } @else {
    <div class="page-wrap">
        <div class="headline">
            <div class="title">
                <div class="title-text headline-small-emphasized">{{ customerDetail.ragioneSociale }}</div>

                <button
                    matIconButton
                    type="button"
                    class="notifications-button"
                    [attr.aria-label]="'receipts.ui.apriNotificheCliente' | transloco"
                    [matBadge]="notificationJson.Count"
                    [matBadgeHidden]="notificationJson.Count === 0"
                    matBadgeColor="warn"
                    matBadgePosition="above after"
                    (click)="onNotificationsButtonClick()"
                    #notificationsOrigin
                >
                    <i class="fa-solid fa-bell"></i>
                </button>
            </div>

            <div class="customer-info label-small">{{ 'receipts.ui.descrizioneZona' | transloco: { value0: (customerDetail.zona?.nome || '-') } }}</div>
            <div class="customer-info label-small">{{ 'receipts.ui.pIva' | transloco: { value0: (customerDetail.partitaIva) } }}</div>

            @if (selectedTabIndex === 1 && hasPaymentsToSettle) {
                <button
                    matButton="filled"
                    type="button"
                    class="new-payment-desktop-button"
                    *uiCan="CAPS.incassoCrea"
                    [attr.aria-label]="'receipts.ui.mostraONascondiNuovoIncasso' | transloco"
                    [attr.aria-expanded]="newPaymentPanelOpen"
                    (click)="toggleNewPaymentPanel()"
                >
                    <i class="fa-regular fa-plus" aria-hidden="true"></i>
                    <span>{{ 'receipts.ui.incasso' | transloco }}</span>
                </button>
            }
        </div>

        <mat-tab-group
            animationDuration="0ms"
            class="tabs"
            [selectedIndex]="selectedTabIndex"
            (selectedIndexChange)="onTabIndexChange($event)"
            mat-align-tabs="start"
        >
            <mat-tab [label]="'receipts.ui.anagrafica' | transloco">
                <div class="anagrafica-sections">
                    <div class="anagrafica-header">
                        <span class="anagrafica-title title-medium-emphasized">{{ 'receipts.ui.informazioniAnagrafiche' | transloco }}</span>
                    </div>

                    <div class="anagrafica-overview">
                        @for (field of anagraficaFields; track field.key) {
                            <div class="anagrafica-overview-field anagrafica-overview-card">
                                <span class="label-small anagrafica-overview-label">{{ field.label }}</span>
                                <span class="label-small-emphasized anagrafica-overview-value">
                                    @if (field.key === 'clienteDal') {
                                        {{ customerDetail.clienteDal ? (customerDetail.clienteDal | date:'dd/MM/yyyy') : '-' }}
                                    } @else {
                                        {{ getAnagraficaValue(field.key) }}
                                    }
                                </span>
                            </div>

                            @if (!$last) {
                                <hr class="anagrafica-overview-divider" />
                            }
                        }
                    </div>

                    <div class="contacts">
                        <span class="contacts-title title-medium-emphasized">{{ 'receipts.ui.contatti' | transloco }}</span>

                        <button
                            matIconButton
                            type="button"
                            class="contacts-action contacts-action-mobile"
                            [attr.aria-label]="'receipts.ui.aggiungiContatto' | transloco"
                            (click)="openAddContactDialog()"
                        >
                            <i class="fa-regular fa-user-plus"></i>
                        </button>

                        <button
                            matButton="filled"
                            type="button"
                            class="contacts-action-filled"
                            [attr.aria-label]="'receipts.ui.aggiungiContatto' | transloco"
                            (click)="openAddContactDialog()"
                        >
                            <span class="contacts-action-filled-content">
                                <i class="fa-regular fa-user-plus"></i>
                                <span>{{ 'receipts.ui.aggiungiContatto' | transloco }}</span>
                            </span>
                        </button>
                    </div>

                    <div class="contacts-list">
                        <!-- TODO: Introdurre eventualmente ciclo for quando dettaglio sarà completo -->
                        @for (contact of customerContacts; track contact.id) {
                        <div class="contact-element contact-element-mobile">
                            <div class="contact-element-header">
                                <div class="contact-element-content">
                                    <span class="body-medium-emphasized">{{ contact.nominativo || '-' }}</span>
                                    <span class="body-small">{{ contact.ruolo || '-' }}</span>
                                </div>

                                <div class="contact-element-actions">
                                    <button
                                        matIconButton
                                        type="button"
                                        class="contacts-action"
                                        [attr.aria-label]="(('receipts.ui.chiamaContatto' | transloco) + ' ') + contact.nominativo"
                                        (click)="openContactPhone(contact)"
                                        [disabled]="!contact.cellulare && !contact.telefono"
                                    >
                                        <i class="fa-regular fa-phone"></i>
                                    </button>

                                    <button
                                        matIconButton
                                        type="button"
                                        class="contacts-action"
                                        [attr.aria-label]="(('receipts.ui.altreAzioniContatto' | transloco) + ' ') + contact.nominativo"
                                        (click)="setSelectedContact(contact)"
                                        [matMenuTriggerFor]="contactActionsMenu"
                                    >
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="contact-element-details">
                                <div class="contact-element-detail-item">
                                    <span class="body-medium">{{ 'receipts.ui.telefono' | transloco }}</span>
                                    <span class="body-medium-emphasized">{{ contact.telefono || '-' }}</span>
                                </div>

                                <div class="contact-element-detail-item">
                                    <span class="body-medium">{{ 'receipts.ui.cellulare' | transloco }}</span>
                                    <span class="body-medium-emphasized">{{ contact.cellulare || '-' }}</span>
                                </div>

                                <div class="contact-element-detail-item">
                                    <span class="body-medium">Fax</span>
                                    <span class="body-medium-emphasized">{{ contact.fax || '-' }}</span>
                                </div>

                                <div class="contact-element-detail-item">
                                    <span class="body-medium">Email</span>
                                    <span class="body-medium-emphasized">{{ contact.email || '-' }}</span>
                                </div>

                                <div class="contact-element-detail-item">
                                    <span class="body-medium">{{ 'receipts.ui.note' | transloco }}</span>
                                    <span class="body-medium-emphasized">{{ contact.note || '-' }}</span>
                                </div>
                            </div>
                        </div>
                            <div class="contact-card">
                                <div class="contact-card-content">
                                    <div class="contact-card-header">
                                        <div class="contact-card-header-layout">
                                            <div class="contact-card-header-content">
                                                <span class="body-medium-emphasized">{{ contact.nominativo || '-' }}</span>

                                                <span class="contact-card-description">
                                                    @if (contact.principale) {
                                                        <i class="fa-solid fa-circle-check"></i>
                                                    }

                                                    <span class="body-small">{{ contact.ruolo || '-' }}</span>
                                                </span>
                                            </div>

                                            <button
                                                matIconButton
                                                type="button"
                                                class="contact-card-action"
                                                [attr.aria-label]="(('receipts.ui.altreAzioniContatto' | transloco) + ' ') + contact.nominativo"
                                                (click)="setSelectedContact(contact)"
                                                [matMenuTriggerFor]="contactActionsMenu"
                                            >
                                                <i class="fa-solid fa-ellipsis-vertical"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="contact-card-divider"></div>
                                    <div class="contact-card-details">
                                        <div class="contact-card-detail-item">
                                            <span class="body-medium">{{ 'receipts.ui.telefono' | transloco }}</span>
                                            <span class="body-medium-emphasized">{{ contact.telefono || '-' }}</span>
                                        </div>

                                        <div class="contact-card-detail-item">
                                            <span class="body-medium">{{ 'receipts.ui.cellulare' | transloco }}</span>
                                            <span class="body-medium-emphasized">{{ contact.cellulare || '-' }}</span>
                                        </div>

                                        <div class="contact-card-detail-item">
                                            <span class="body-medium">Fax</span>
                                            <span class="body-medium-emphasized">{{ contact.fax || '-' }}</span>
                                        </div>

                                        <div class="contact-card-detail-item">
                                            <span class="body-medium">Email</span>
                                            <span class="body-medium-emphasized">{{ contact.email || '-' }}</span>
                                        </div>

                                        <div class="contact-card-detail-item">
                                            <span class="body-medium">{{ 'receipts.ui.note' | transloco }}</span>
                                            <span class="body-medium-emphasized">{{ contact.note || '-' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            @if (!$last) {
                                <hr class="anagrafica-overview-divider" />
                            }
                        }
                    </div>

                    <mat-menu #contactActionsMenu="matMenu" class="action-menu">
                        <div class="action-wrap">
                            <button class="action-menu-item" mat-menu-item (click)="openSelectedContactEmail()" [disabled]="!selectedContact?.email">
                              <span class="action-menu-content">
                                <i class="fa-regular fa-envelope action-menu-icon"></i>
                                <span class="label-large">Email</span>
                              </span>
                            </button>
                        </div>
                        <div class="action-wrap">
                            <button class="action-menu-item" mat-menu-item (click)="selectedContact && openEditContactDialog(selectedContact)">
                              <span class="action-menu-content">
                                <i class="fa-regular fa-pencil action-menu-icon"></i>
                                <span class="label-large">{{ 'receipts.ui.modifica' | transloco }}</span>
                              </span>
                            </button>
                        </div>
                        <hr class="action-menu-divider">
                        <div class="action-wrap">
                            <button class="action-menu-item" mat-menu-item (click)="deleteSelectedContact()">
                              <span class="action-menu-content">
                                <i class="fa-regular fa-trash action-menu-icon-delete"></i>
                                <span class="label-large action-menu-label-delete">{{ 'receipts.ui.elimina' | transloco }}</span>
                              </span>
                            </button>
                        </div>
                    </mat-menu>
                </div>
            </mat-tab>
            <mat-tab [label]="'receipts.ui.partiteDaSaldare' | transloco">
                @if (!hasPaymentsToSettle) {
                    <div class="payments-empty-state payments-empty-state-mobile">
                        <span class="body-medium">{{ 'receipts.ui.nessunaPartitaTrovataDaSaldare' | transloco }}</span>
                    </div>
                }

                @if (newPaymentPanelOpen) {
                    <div class="new-payment-mobile-options">
                        <div class="new-payment-mobile-methods">
                            <button
                                matButton="outlined"
                                type="button"
                                [disabled]="selectedPaymentMethod === 'checks'"
                                (click)="openCashBreakdown()"
                            >
                                {{ 'receipts.ui.contanti' | transloco }}
                            </button>
                            <button
                                matButton="outlined"
                                type="button"
                                [disabled]="selectedPaymentMethod === 'cash'"
                                (click)="openChecksBreakdown()"
                            >
                                {{ 'receipts.ui.assegni' | transloco }}
                            </button>
                        </div>

                        <button
                            matIconButton
                            type="button"
                            class="new-payment-mobile-delete"
                            *uiCan="CAPS.incassoElimina"
                            [attr.aria-label]="'receipts.ui.eliminaIncasso' | transloco"
                            [disabled]="!store.isPersisted || store.isSaving"
                            (click)="resetNewPayment()"
                        >
                            <i class="fa-regular fa-trash" aria-hidden="true"></i>
                        </button>

                        <button
                            matButton="outlined"
                            type="button"
                            class="new-payment-mobile-advance"
                            [disabled]="store.totaleIncasso <= 0 || store.isSaving"
                            (click)="openAdvanceExpenses()"
                        >
                            <i class="fa-regular fa-plus" aria-hidden="true"></i>
                            <span>{{ 'receipts.ui.spese' | transloco }}</span>
                        </button>
                    </div>

                    <div class="payment-registration-mobile">
                        <span class="label-medium-emphasized">{{ 'receipts.ui.registrazioneIncasso' | transloco }}</span>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{ 'receipts.ui.accontiSpese2' | transloco }}</mat-label>
                            <input matInput [value]="formatAmount(advanceExpensesTotal)" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{ 'receipts.ui.totaleIncasso' | transloco }}</mat-label>
                            <input matInput [value]="formatAmount(totalIncome)" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{ 'receipts.ui.residuoDisponibile2' | transloco }}</mat-label>
                            <input matInput [value]="formatAmount(availableResidual)" readonly />
                        </mat-form-field>
                    </div>
                }

                <div class="payments-desktop-content">
                    @if (newPaymentPanelOpen) {
                        <mat-card class="new-payment-desktop-panel">
                            <mat-card-content class="new-payment-desktop-panel-content">
                                <span class="new-payment-desktop-panel-title title-medium-emphasized">
                                    {{ 'receipts.ui.registrazioneIncasso' | transloco }}
                                </span>

                                <button
                                    matButton="outlined"
                                    type="button"
                                    class="new-payment-desktop-method"
                                    [disabled]="selectedPaymentMethod === 'checks'"
                                    (click)="openCashBreakdown()"
                                >
                                    {{ 'receipts.ui.contanti' | transloco }}
                                </button>

                                <button
                                    matButton="outlined"
                                    type="button"
                                    class="new-payment-desktop-method"
                                    [disabled]="selectedPaymentMethod === 'cash'"
                                    (click)="openChecksBreakdown()"
                                >
                                    {{ 'receipts.ui.assegni' | transloco }}
                                </button>

                                <button
                                    matButton="outlined"
                                    type="button"
                                    class="new-payment-desktop-method"
                                    [disabled]="store.totaleIncasso <= 0 || store.isSaving"
                                    (click)="openAdvanceExpenses()"
                                >
                                    <i class="fa-regular fa-plus" aria-hidden="true"></i>
                                    <span>{{ 'receipts.ui.spese' | transloco }}</span>
                                </button>

                                <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    class="new-payment-desktop-field new-payment-desktop-account"
                                >
                                    <mat-label>{{ 'receipts.ui.accontiSpese2' | transloco }}</mat-label>
                                    <input matInput [value]="formatAmount(advanceExpensesTotal)" readonly />
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    class="new-payment-desktop-field new-payment-desktop-total"
                                >
                                    <mat-label>{{ 'receipts.ui.totaleIncasso' | transloco }}</mat-label>
                                    <input matInput [value]="formatAmount(totalIncome)" readonly />
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    class="new-payment-desktop-field new-payment-desktop-remainder"
                                >
                                    <mat-label>{{ 'receipts.ui.residuoDisponibile2' | transloco }}</mat-label>
                                    <input matInput [value]="formatAmount(availableResidual)" readonly />
                                </mat-form-field>

                                <button
                                    matButton="filled"
                                    type="button"
                                    class="new-payment-desktop-action new-payment-desktop-confirm"
                                    [disabled]="!store.canConfirm || store.isSaving || !puoConfermareIncasso"
                                    (click)="openReceipt()"
                                >
                                    {{ 'receipts.ui.confermaEdEmettiRicevuta' | transloco }}
                                </button>

                                <button
                                    matButton="outlined"
                                    type="button"
                                    class="new-payment-desktop-action new-payment-desktop-delete"
                                    *uiCan="CAPS.incassoElimina"
                                    [disabled]="!store.isPersisted || store.isSaving"
                                    (click)="resetNewPayment()"
                                >
                                    {{ 'receipts.ui.elimina' | transloco }}
                                </button>
                            </mat-card-content>
                        </mat-card>
                    }

                    @if (hasPaymentsToSettle) {
                        <ui-table-view
                            class="payments-desktop-table"
                            [columnsInfo]="partiteDaSaldareColumns"
                            [data]="partiteDaSaldareTable"
                            (reloadData)="onPaymentAmountChanged()"
                        />
                    } @else {
                        <div class="payments-empty-state payments-empty-state-desktop">
                            <span class="body-medium">{{ 'receipts.ui.nessunaPartitaTrovataDaSaldare' | transloco }}</span>
                        </div>
                    }
                </div>

                @if (newPaymentPanelOpen) {
                    <div class="payments-processing-list">
                        <span class="label-medium-emphasized">{{ 'receipts.ui.elencoPartiteDaSaldareOInLavorazione' | transloco }}</span>

                        @for (payment of partiteDaSaldare; track payment.idDocumento) {
                            <div class="payment-processing-card">
                                <div class="payment-processing-card-top">
                                    <div class="payment-processing-data-row">
                                        <span class="payment-processing-field">
                                            <span class="body-small">{{ 'receipts.ui.idDoc' | transloco }}</span>
                                            <span class="body-small-emphasized">{{ payment.idDocumento }}</span>
                                        </span>
                                    </div>

                                    <div class="payment-processing-data-row">
                                        <span class="payment-processing-field">
                                            <span class="body-small">{{ 'receipts.ui.dataDoc' | transloco }}</span>
                                            <span class="body-small-emphasized">{{ payment.dataDocumento | date:'dd/MM/yyyy' }}</span>
                                        </span>
                                    </div>

                                    <div class="payment-processing-data-row">
                                        <span class="payment-processing-field">
                                            <span class="body-small">{{ 'receipts.ui.scad' | transloco }}</span>
                                            <span class="body-small-emphasized">{{ payment.dataScadenza | date:'dd/MM/yyyy' }}</span>
                                        </span>
                                    </div>

                                    <div class="payment-processing-data-row">
                                        <span class="payment-processing-field">
                                            <span class="body-small">{{ 'receipts.ui.descrizione2' | transloco }}</span>
                                            <span class="body-small-emphasized">{{ payment.descrizione }}</span>
                                        </span>
                                    </div>

                                    <div class="payment-processing-data-row">
                                        <span class="payment-processing-field">
                                            <span class="body-small">{{ 'receipts.ui.totaleFattura3' | transloco }}</span>
                                            <span class="body-small-emphasized">
                                                {{ payment.totaleFattura | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                            </span>
                                        </span>
                                    </div>

                                    <div class="payment-processing-data-row">
                                        <span class="payment-processing-field">
                                            <span class="body-small">{{ 'receipts.ui.importoResiduo' | transloco }}</span>
                                            <span class="body-small-emphasized">
                                                {{ payment.importoResiduo | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <hr class="payment-processing-card-divider" />
                                <div class="payment-processing-card-bottom">
                                    <mat-form-field
                                        appearance="outline"
                                        subscriptSizing="dynamic"
                                        [class.payment-assigned-field-disabled]="!payment.nuovoIncassoAttivo"
                                    >
                                        <mat-label>{{ 'receipts.ui.importoAssegnato' | transloco }}</mat-label>
                                        <span matTextPrefix>€&nbsp;</span>
                                        <input
                                            matInput
                                            type="text"
                                            inputmode="decimal"
                                            [disabled]="!payment.nuovoIncassoAttivo"
                                            [value]="formatAssignedAmount(getAssignedAmount(payment.idDocumento))"
                                            (focus)="prepareAssignedAmountInput(payment.idDocumento, $event)"
                                            (input)="updateAssignedAmount(payment.idDocumento, $event)"
                                            (blur)="commitAssignedAmount(payment.idDocumento, $event)"
                                        />
                                        @if (getAssignedAmount(payment.idDocumento) > 0) {
                                            <button
                                                mat-icon-button
                                                matSuffix
                                                type="button"
                                                class="clear-assigned-amount-button"
                                                [disabled]="!payment.nuovoIncassoAttivo"
                                                [attr.aria-label]="(('receipts.ui.svuotaImportoAssegnatoPer' | transloco) + ' ') + payment.idDocumento"
                                                (click)="clearAssignedAmount(payment.idDocumento, $event)"
                                            >
                                                <i class="fa-regular fa-xmark" aria-hidden="true"></i>
                                            </button>
                                        }
                                    </mat-form-field>

                                    <button
                                        mat-stroked-button
                                        type="button"
                                        [disabled]="!payment.nuovoIncassoAttivo"
                                        (click)="saldaPayment(payment)"
                                    >
                                        {{ 'receipts.ui.saldato' | transloco }}
                                    </button>
                                </div>
                            </div>
                        }
                    </div>

                    <button
                        matButton="filled"
                        type="button"
                        class="payment-confirm-button payment-confirm-button-mobile title-medium"
                        [disabled]="!store.canConfirm || store.isSaving || !puoConfermareIncasso"
                        (click)="openReceipt()"
                    >
                        {{ 'receipts.ui.confermaEdEmettiRicevuta' | transloco }}
                    </button>
                } @else {
                    <div class="payments-mobile-list">
                        @for (payment of partiteDaSaldare; track payment.idDocumento) {
                            <div class="payment-mobile-card">
                                <div class="payment-mobile-data">
                                    <div class="payment-mobile-data-block">
                                        <span class="body-medium-emphasized">{{ payment.idDocumento }}</span>
                                        <span class="body-medium">
                                            {{ 'receipts.ui.residuo3' | transloco: { value0: (payment.importoResiduo | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR') } }}
                                        </span>
                                    </div>

                                    <div class="payment-mobile-data-block">
                                        <span class="body-medium-emphasized">
                                            {{ payment.totaleFattura | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                        </span>
                                        <span class="body-medium">
                                            {{ 'receipts.ui.scad2' | transloco: { value0: (payment.dataScadenza | date:'dd/MM/yyyy') } }}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        }
                    </div>
                }

                @if (!newPaymentPanelOpen && hasPaymentsToSettle) {
                    <button
                        matFab
                        extended
                        type="button"
                        class="new-payment-button"
                        *uiCan="CAPS.incassoCrea"
                        [attr.aria-label]="'receipts.ui.apriNuovoIncasso' | transloco"
                        (click)="toggleNewPaymentPanel()"
                    >
                        <i class="fa-regular fa-plus" aria-hidden="true"></i>
                        <span class="new-payment-label title-medium">{{ 'receipts.ui.incasso' | transloco }}</span>
                    </button>
                }
            </mat-tab>
            <mat-tab [label]="'receipts.ui.estrattoConto' | transloco">
                <div class="statement-content">
                    @if (statementCustomerBalances.length) {
                        <section class="statement-customer-balances" [attr.aria-label]="'receipts.ui.riepilogoSaldiClienti' | transloco">
                            <span class="statement-customer-balances-title label-medium-emphasized">
                                {{ 'receipts.ui.riepilogoSaldiClienti' | transloco }}
                            </span>

                            <div class="statement-customer-balances-card">
                                <div class="statement-customer-balance-row statement-customer-balance-header body-medium">
                                    <span>{{ 'receipts.ui.codiceCliente' | transloco }}</span>
                                    <span>{{ 'receipts.ui.saldo' | transloco }}</span>
                                </div>

                                @for (balance of statementCustomerBalances; track $index) {
                                    <div class="statement-customer-balance-row statement-customer-balance-value body-medium-emphasized">
                                        <span>{{ balance.codiceCliente }}</span>
                                        <span>{{ balance.saldo | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}</span>
                                    </div>
                                }

                                <div class="statement-customer-balance-row statement-customer-balance-total">
                                    <span class="body-medium">{{ 'receipts.ui.saldoTotale' | transloco }}</span>
                                    <span class="body-medium-emphasized">
                                        {{ statementCustomerTotalBalance | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                    </span>
                                </div>
                            </div>

                            <div class="statement-customer-balances-list">
                                @for (balance of statementCustomerBalances; track $index) {
                                    <div class="statement-customer-balance">
                                        <span class="body-small">{{ 'receipts.ui.codiceCliente' | transloco }}</span>
                                        <span class="body-medium-emphasized">{{ balance.codiceCliente }}</span>
                                        <span class="body-small">{{ 'receipts.ui.saldo' | transloco }}</span>
                                        <span class="body-medium-emphasized">
                                            {{ balance.saldo | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                        </span>
                                    </div>
                                }

                                <div class="statement-customer-balance">
                                    <span class="body-medium-emphasized">{{ 'receipts.ui.saldoTotale' | transloco }}</span>
                                    <span class="body-medium-emphasized">
                                        {{ statementCustomerTotalBalance | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                    </span>
                                </div>
                            </div>
                        </section>
                    }

                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="statement-filter"
                    >
                        <mat-select
                            [(ngModel)]="statementType"
                            (selectionChange)="loadStatement()"
                            [attr.aria-label]="'receipts.ui.filtraLePartiteDellEstrattoConto' | transloco"
                        >
                            <mat-option value="all">{{ 'receipts.ui.visualizzaTutteLePartite' | transloco }}</mat-option>
                            <mat-option value="open">{{ 'receipts.ui.partiteDaSaldare' | transloco }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div class="statement-documents">
                        @for (document of statementInvoices; track $index; let documentIndex = $index) {
                            <div
                                class="statement-document"
                                [class.statement-document--expanded]="isStatementInvoiceExpanded(documentIndex)"
                            >
                                <button
                                    type="button"
                                    class="statement-document-summary"
                                    [attr.aria-expanded]="isStatementInvoiceExpanded(documentIndex)"
                                    [attr.aria-controls]="'statement-document-details-' + documentIndex"
                                    (click)="toggleStatementInvoice(documentIndex)"
                                >
                                    <span class="statement-document-summary-text">
                                        <span class="body-medium-emphasized">
                                            {{ document.fattura }}
                                        </span>

                                        <span class="statement-document-summary-values body-medium">
                                            <span>
                                                {{ 'receipts.ui.tot2' | transloco: { value0: (document.totale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR') } }}
                                            </span>
                                            <span>
                                                {{ 'receipts.ui.saldo2' | transloco: { value0: (document.saldoPartita | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR') } }}
                                            </span>
                                        </span>
                                    </span>

                                    <i
                                        class="fa-regular fa-chevron-down statement-document-chevron statement-document-chevron--mobile"
                                        [class.statement-document-chevron--mobile-expanded]="isStatementInvoiceExpanded(documentIndex)"
                                        aria-hidden="true"
                                    ></i>
                                </button>

                                @if (isStatementInvoiceExpanded(documentIndex)) {
                                    <div
                                        class="statement-document-details"
                                        [id]="'statement-document-details-' + documentIndex"
                                    >
                                        @for (movement of document.righe; track $index) {
                                            <div
                                                class="statement-mobile-movement"
                                                [attr.aria-label]="(('receipts.ui.movimentoDel' | transloco) + ' ') + movement.dataDocumento"
                                            >
                                                <div class="statement-mobile-movement-heading">
                                                    <span class="statement-mobile-movement-cause body-medium-emphasized">
                                                        {{ movement.causale }}
                                                    </span>

                                                    <span class="statement-mobile-movement-amount body-medium-emphasized">
                                                        {{ movement.importo | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                                    </span>

                                                    <span
                                                        class="statement-mobile-movement-type label-medium-emphasized"
                                                        [class.statement-mobile-movement-type--debit]="movement.dareAvere === 'D'"
                                                        [class.statement-mobile-movement-type--credit]="movement.dareAvere === 'A'"
                                                    >
                                                        {{ movement.dareAvere }}
                                                    </span>
                                                </div>

                                                <div class="statement-mobile-movement-data body-medium">
                                                    <span>
                                                        {{ 'receipts.ui.doc' | transloco: { value0: (movement.numeroDocumento) } }}
                                                    </span>
                                                    <span>
                                                        {{ 'receipts.ui.rif' | transloco: { value0: (movement.numeroRiferimento) } }}
                                                    </span>
                                                    <span>
                                                        {{ 'receipts.ui.data4' | transloco: { value0: (movement.dataDocumento | date:'dd/MM/yyyy') } }}
                                                    </span>
                                                    <span>
                                                        {{ 'receipts.ui.scad2' | transloco: { value0: (movement.dataScadenza | date:'dd/MM/yyyy') } }}
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>

                    <div class="statement-desktop-table">
                        <mat-card appearance="elevated" class="statement-desktop-table-container">
                            <mat-card-content>
                                <table>
                                    <thead>
                                        <tr>
                                            <th class="label-large">{{ 'receipts.ui.stato' | transloco }}</th>
                                            <th class="label-large">{{ 'receipts.ui.dataDoc2' | transloco }}</th>
                                            <th class="label-large">{{ 'receipts.ui.nDoc' | transloco }}</th>
                                            <th class="label-large">{{ 'receipts.ui.causale' | transloco }}</th>
                                            <th class="label-large">{{ 'receipts.ui.nRif' | transloco }}</th>
                                            <th class="label-large">{{ 'receipts.ui.dataScad' | transloco }}</th>
                                            <th class="statement-table-number label-large">{{ 'receipts.ui.importo' | transloco }}</th>
                                            <th class="label-large">D/A</th>
                                            <th class="statement-table-number label-large">{{ 'receipts.ui.residuo2' | transloco }}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        @for (document of statementInvoices; track $index; let documentIndex = $index) {
                                            <tr
                                                class="statement-table-summary-row"
                                                role="button"
                                                tabindex="0"
                                                [attr.aria-expanded]="isStatementInvoiceExpanded(documentIndex)"
                                                (click)="toggleStatementInvoice(documentIndex)"
                                                (keydown.enter)="toggleStatementInvoice(documentIndex)"
                                                (keydown.space)="toggleStatementInvoice(documentIndex); $event.preventDefault()"
                                            >
                                                <td>
                                                    <i
                                                        class="fa-regular fa-chevron-right statement-document-chevron"
                                                        [class.statement-document-chevron--expanded]="isStatementInvoiceExpanded(documentIndex)"
                                                        aria-hidden="true"
                                                    ></i>
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td>{{ 'receipts.ui.saldoPartita' | transloco }}</td>
                                                <td>{{ document.numeroRiferimento }}</td>
                                                <td></td>
                                                <td class="statement-table-number">
                                                    {{ document.saldoPartita | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                                </td>
                                                <td></td>
                                                <td></td>
                                            </tr>

                                            @if (isStatementInvoiceExpanded(documentIndex)) {
                                                @for (movement of document.righe; track $index) {
                                                    <tr class="statement-table-detail-row">
                                                        <td>{{ movement.stato }}</td>
                                                        <td>{{ movement.dataDocumento | date:'dd/MM/yyyy' }}</td>
                                                        <td>{{ movement.numeroDocumento }}</td>
                                                        <td>{{ movement.causale }}</td>
                                                        <td>{{ movement.numeroRiferimento }}</td>
                                                        <td>{{ movement.dataScadenza | date:'dd/MM/yyyy' }}</td>
                                                        <td class="statement-table-number">
                                                            {{ movement.importo | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                                        </td>
                                                        <td>{{ movement.dareAvere }}</td>
                                                        <td class="statement-table-number">
                                                            {{ movement.residuo | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                                        </td>
                                                    </tr>
                                                }
                                            }
                                        }
                                    </tbody>
                                </table>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <div class="statement-summary">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{ 'receipts.ui.rischio' | transloco }}</mat-label>
                            <input matInput [value]="formatAmount(statementSummary.rischio)" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{ 'receipts.ui.rischioAScadere' | transloco }}</mat-label>
                            <input matInput [value]="formatAmount(statementSummary.rischioAScadere)" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{ 'receipts.ui.scaduti' | transloco }}</mat-label>
                            <input matInput [value]="formatAmount(statementSummary.scaduti)" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{ 'receipts.ui.aScadere' | transloco }}</mat-label>
                            <input matInput [value]="formatAmount(statementSummary.aScadere)" readonly />
                        </mat-form-field>
                    </div>
                </div>
            </mat-tab>
            <mat-tab [label]="'receipts.ui.storicoPartite' | transloco">
                <div class="history-search">
                    <span class="history-search-title body-medium-emphasized">
                        {{ 'receipts.ui.ricercaPartiteInArchivio' | transloco }}
                    </span>

                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="history-date-field"
                    >
                        <mat-label>{{ 'receipts.ui.dal' | transloco }}</mat-label>
                        <input
                            matInput
                            [matDatepicker]="historyDateFromPicker"
                            [(ngModel)]="historyDateFrom"
                            [placeholder]="'receipts.ui.datePlaceholder' | transloco"
                        />
                        <mat-datepicker-toggle matIconSuffix [for]="historyDateFromPicker" />
                        <mat-datepicker #historyDateFromPicker />
                    </mat-form-field>

                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        class="history-date-field"
                    >
                        <mat-label>{{ 'receipts.ui.al' | transloco }}</mat-label>
                        <input
                            matInput
                            [matDatepicker]="historyDateToPicker"
                            [(ngModel)]="historyDateTo"
                            [placeholder]="'receipts.ui.datePlaceholder' | transloco"
                        />
                        <mat-datepicker-toggle matIconSuffix [for]="historyDateToPicker" />
                        <mat-datepicker #historyDateToPicker />
                    </mat-form-field>

                    <button
                        matButton="filled"
                        type="button"
                        class="history-search-button"
                        (click)="cercaStorico()"
                    >
                        {{ 'receipts.ui.cerca' | transloco }}
                    </button>

                    <div class="history-results">
                        @for (payment of historyPayments; track payment.idDocumento) {
                            <div class="history-card">
                                <div class="history-card-column">
                                    <span class="body-medium-emphasized">
                                        {{ payment.idDocumento }}
                                    </span>
                                    <span class="body-medium">
                                        {{ 'receipts.ui.chiusaIl' | transloco: { value0: (payment.dataChiusura | date:'dd/MM/yyyy') } }}
                                    </span>
                                </div>

                                <div class="history-card-column history-card-column--end">
                                    <span class="body-medium-emphasized">
                                        {{ payment.totaleFattura | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
                                    </span>
                                    <span class="body-medium">
                                        {{ payment.situazione }}
                                    </span>
                                </div>
                            </div>
                        } @empty {
                            <div class="payments-empty-state">
                                <span class="body-medium">{{ 'receipts.ui.nessunaPartitaChiusaTrovata' | transloco }}</span>
                            </div>
                        }
                    </div>

                    <ui-table-view
                        class="history-desktop-table"
                        [columnsInfo]="historyPaymentColumns"
                        [data]="historyPaymentsTable"
                    />
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    }

    <ng-template #notificationsPanel>
        <div class="notifications-panel" role="dialog" [attr.aria-label]="'receipts.ui.notificheCliente' | transloco">
            <div class="notifications-panel-header">
                <span class="title-large-emphasized">{{ 'receipts.ui.notifiche' | transloco }}</span>

                <button
                    matIconButton
                    type="button"
                    [attr.aria-label]="'receipts.ui.chiudiNotifiche' | transloco"
                    (click)="closeNotificationsPanel()"
                >
                    <i class="fa-regular fa-xmark"></i>
                </button>
            </div>

            <div class="notifications-panel-content">
                <div class="notifications-list">
                    @for (item of notificationJson.Notifications; track item.Id) {
                        <div class="notification-card" [class]="getNotificationCardClass(item.Severity)">
                            <div class="notification-card-header">
                                <div class="notification-card-header-container">
                                    <div class="notification-card-header-icon-container">
                                        <div class="notification-card-icon">
                                            <i [class]="getNotificationIconClass(item.Severity) + ' ' + getNotificationIconColorClass(item.Severity)"></i>
                                        </div>
                                    </div>

                                    <div class="notification-card-header-content">
                                        <span class="body-medium-emphasized notification-card-title" [class]="getNotificationIconColorClass(item.Severity)">{{ item.Title }}</span>
                                        <span class="body-medium notification-card-description">{{ item.Description || '-' }}</span>
                                    </div>
                                </div>

                                <div class="notification-card-header-close">
                                    <button matIconButton type="button" (click)="$event.stopPropagation()">
                                        <i class="fa-regular fa-xmark"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="notification-card-footer">
                                @if (item.ToAction) {
                                    <button matButton type="button" class="notification-card-action">
                                        <span class="notification-card-action-content">
                                            <i class="fa-regular fa-up-right-from-square"></i>
                                            <span>{{ getNotificationActionLabel(item) }}</span>
                                        </span>
                                    </button>
                                }
                            </div>
                        </div>
                    }

                    @if (!notificationJson.Notifications?.length) {
                        <div class="notifications-empty-state">
                            <span class="body-large-emphasized">{{ 'receipts.ui.nessunaNotifica' | transloco }}</span>
                            <span class="body-medium">{{ 'receipts.ui.quandoArriverannoNuoveNotificheLeTroveraiQui' | transloco }}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </ng-template>

